"use client";

import { useState } from "react";

// Dışarıdan gelecek verinin yapısı (TypeScript)
interface AboutTimelineProps {
    timelineData?: {
        title?: string;
        highlight?: string;
        description?: string;
        items?: Array<{
            id: string;
            year: string;
            title: string;
            description: string;
            isActive: boolean;
            order: number;
        }>;
    };
}

export default function AboutTimeline({ timelineData }: AboutTimelineProps) {
    // 1. Verileri hazırla (Aktif olanları filtrele ve sırala)
    const items = timelineData?.items
        ? timelineData.items.filter(item => item.isActive).sort((a, b) => a.order - b.order)
        : [];

    // 2. Varsayılan olarak en son eklenen (veya en son tarihteki) öğeyi aktif yap
    const [activeTimeline, setActiveTimeline] = useState<number>(
        items.length > 0 ? items.length - 1 : 0
    );

    // 3. Eğer Timeline kapalıysa veya hiç öğe girilmemişse boşluk yaratmadan gizle
    if (!timelineData || items.length === 0) {
        return null;
    }

    return (
        <section className="bg-white py-20">
            <div className="container mx-auto px-4">

                {/* Başlık Alanı */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                        {timelineData.title || "Yol"} <span style={{ color: 'var(--color-primary)' }}>{timelineData.highlight || "Hikayemiz"}</span>
                    </h2>
                    {timelineData.description && (
                        <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                            {timelineData.description}
                        </p>
                    )}
                </div>

                <div className="max-w-4xl mx-auto">
                    <div className="relative">

                        {/* Orta Çizgi */}
                        <div
                            className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full opacity-20"
                            style={{ backgroundColor: 'var(--color-primary)' }}
                        ></div>

                        {/* Zaman Çizelgesi Öğeleri */}
                        {items.map((item, index) => {
                            const isActive = activeTimeline === index;

                            return (
                                <div
                                    key={item.id}
                                    className={`flex items-center mb-12 cursor-pointer group ${index % 2 === 0 ? "flex-row" : "flex-row-reverse"}`}
                                    onClick={() => setActiveTimeline(index)}
                                >
                                    {/* Kart Alanı */}
                                    <div className={`w-1/2 ${index % 2 === 0 ? "pr-8 text-right" : "pl-8"}`}>
                                        <div
                                            className="p-6 rounded-2xl shadow-sm border transition-all duration-300 group-hover:shadow-md"
                                            style={{
                                                backgroundColor: isActive ? 'color-mix(in srgb, var(--color-primary), transparent 95%)' : '#ffffff',
                                                borderColor: isActive ? 'color-mix(in srgb, var(--color-primary), transparent 80%)' : '#f3f4f6'
                                            }}
                                        >
                                            <div
                                                className="font-bold text-lg mb-1 transition-colors"
                                                style={{ color: 'var(--color-primary)' }}
                                            >
                                                {item.year}
                                            </div>
                                            <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
                                            <p className="text-gray-600 text-sm">{item.description}</p>
                                        </div>
                                    </div>

                                    {/* Orta Nokta */}
                                    <div className="relative z-10">
                                        <div
                                            className="w-4 h-4 rounded-full border-4 transition-all duration-300"
                                            style={{
                                                backgroundColor: isActive ? 'var(--color-primary)' : '#ffffff',
                                                borderColor: isActive ? 'var(--color-primary)' : 'color-mix(in srgb, var(--color-primary), transparent 60%)'
                                            }}
                                        ></div>
                                    </div>

                                    {/* Boş Karşı Kolon */}
                                    <div className="w-1/2"></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}